/**
 * `market` namespace — Korean translations.
 *
 * Mirrors `en/market.ts` exactly (compile-checked via `Record<MarketKey, string>`).
 * `/market` 개요 화면: 주요 지수 · 섹터 히트맵 · 공포·탐욕 지수 · 시장 뉴스.
 */
import type { MarketKey } from "../en/market";

export const market: Record<MarketKey, string> = {
  // ── route chrome ──
  eyebrow: "시황",
  title: "시장 개요",
  description: "주요 지수, 섹터 성과, 공포·탐욕 지수, 시장 뉴스를 한눈에.",

  // ── index tiles ──
  indicesTitle: "지수",
  indicesEmpty: "지수 데이터를 불러올 수 없습니다.",

  // ── Fear & Greed gauge ──
  fgiTitle: "공포·탐욕 지수",
  fgiTrend: "90일 추이",
  fgiTrendEmpty: "추이 데이터 없음",
  fgiPrevClose: "전일",
  fgi1Week: "1주",
  fgi1Month: "1개월",
  fgi1Year: "1년",
  fgiEmpty: "공포·탐욕 지수를 불러올 수 없습니다.",

  // ── sector heatmap ──
  sectorsTitle: "섹터",
  sectorsSubtitle: "S&P 500 섹터 ETF · 오늘",
  sectorsEmpty: "섹터 데이터를 불러올 수 없습니다.",

  // ── stock treemap (종목 히트맵) ──
  heatViewSectors: "섹터",
  heatViewStocks: "종목",
  stocksTitle: "종목",
  stocksSubtitle: "시가총액 상위 200 · 비중으로 크기 표시",
  stocksAll: "전체",
  stocksBack: "← 전체 보기",
  stocksEmpty: "종목 데이터를 불러올 수 없습니다.",
  stocksGateTitle: "종목",
  stocksGateBody: "토스 계정을 연동하면 실시간 종목 히트맵을 볼 수 있습니다.",
  stocksBaseline: "{date} 종가 기준",
  stocksNoBaseline: "등락률은 다음 장 마감 후부터 표시됩니다.",
  stocksSummaryAll: "전체 섹터 {count}개 종목",
  stocksSummarySector: "{sector} {count}개 종목",
  legendNoData: "데이터 없음",

  // ── SPDR 섹터 표시 이름 (트리맵 그룹 / 드릴다운 헤더) ──
  sectorXLK: "기술",
  sectorXLF: "금융",
  sectorXLE: "에너지",
  sectorXLV: "헬스케어",
  sectorXLI: "산업재",
  sectorXLY: "자유소비재",
  sectorXLP: "필수소비재",
  sectorXLU: "유틸리티",
  sectorXLB: "소재",
  sectorXLRE: "부동산",
  sectorXLC: "커뮤니케이션",

  // ── news ──
  newsTitle: "시장 뉴스",
  newsEmpty: "표시할 뉴스가 없습니다.",

  // ── shared caption (interpolated) ──
  asOf: "{time} 기준",
} as const;
